import '@wlb/shared/i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './ErrorBoundary';
import { initializeGoogleAnalytics } from './features/analytics/initGoogleAnalytics';
import './styles/global.css';

initializeGoogleAnalytics().catch(() => undefined);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
